function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,6h30v18H0V6Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52,8.52h24.96v12.96H2.52v-12.96Z",
    style: {
      fill: "#007a5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52,8.52h24.96L2.52,21.48h24.96L2.52,8.52Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2.16,
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.077,15.007c.256.511.765,1.074,1.219,1.279.022-.511-.14-1.171-.373-1.7l-.846.421Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.617,13.289c.381.822-1.052,2.751,1.287,3.239-.284-.399-.44-1.065-.362-1.587.486.207.973.688,1.164,1.138.807-2.249-1.587-2.036-2.089-2.79Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9,21.57l-.688,2.117,1.8-1.308h-2.225l1.8,1.308-.687-2.117Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M15,21.57l-.688,2.117,1.8-1.308h-2.225l1.8,1.308-.687-2.117Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M21,21.57l-.688,2.117,1.8-1.308h-2.225l1.8,1.308-.687-2.117Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M21,6.09l-.688,2.117,1.8-1.308h-2.225l1.8,1.308-.687-2.117Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M15,6.09l-.688,2.117,1.8-1.308h-2.225l1.8,1.308-.687-2.117Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M9,6.09l-.688,2.117,1.8-1.308h-2.225l1.8,1.308-.687-2.117Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.02l-1.164,3.582,3.047-2.214h-3.766l3.047,2.214-1.164-3.582Z",
    style: {
      fill: "#fcd116"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/GD.43dcfe0c785d852b16cda28deb34b12c.svg";
export { ForwardRef as ReactComponent };